mutation RemoveAliyahFromBarMitzvah($aliyah: ID!, $barMitzvah: String!) {
  removeAliyahFromBarMitzvah(aliyah: $aliyah, barMitzvah: $barMitzvah) {
    ok
    errors
  }
}
